import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

/**
 * Whether the "For You" ("Your work") tab SHELL should exist.
 *
 * Spaces and pinned work are two independent features that happen to share this tab. The
 * shell — the RovoTabs strip, the panel container, mini-modal tab sizing, and the
 * chat/context teardown when leaving the tab — must render when EITHER experiment is on.
 *
 * Do NOT use this to gate spaces-specific or pins-specific CONTENT. Read the individual
 * experiment at the point of use for that, otherwise enabling one feature leaks the other's
 * UI (see `ForYouPanelContent`).
 *
 * Centralised deliberately: this condition previously lived as several ad-hoc copies (two of
 * which were even named `isFypTabsEnabled` while resolving differently), which is how the
 * shell drifted out of sync with the pins experiment.
 */
export const isForYouTabEnabled = (): boolean => {
	const spacesEnabled = FeatureGates.getExperimentValue(
		'rovo_chat_spaces_experiment',
		'isEnabled',
		false,
	);
	const pinnedWorkEnabled = FeatureGates.getExperimentValue(
		'rovo_your_work_tab_pin_objects',
		'isEnabled',
		false,
	);

	return spacesEnabled || pinnedWorkEnabled;
};
